import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  isRefreshing: boolean;
}

/**
 * Visual indicator component for pull-to-refresh
 * Shows a circular icon that rotates as the user pulls down
 * Displays a spinner when refreshing
 */
export default function PullToRefreshIndicator({
  pullDistance,
  isRefreshing,
}: PullToRefreshIndicatorProps) {
  return (
    <div
      className="fixed top-0 left-0 right-0 flex justify-center pointer-events-none z-50 transition-all duration-200"
      style={{
        transform: `translateY(${pullDistance > 0 ? pullDistance - 60 : -60}px)`,
        opacity: pullDistance > 20 ? 1 : 0,
      }}
    >
      <div className="bg-white rounded-full shadow-lg p-3 mt-2">
        {isRefreshing ? (
          <ArrowPathIcon className="animate-spin h-6 w-6 text-blue-600" />
        ) : (
          <ArrowPathIcon
            className="h-6 w-6 text-blue-600 transition-transform duration-200"
            style={{ transform: `rotate(${Math.min(pullDistance * 4, 360)}deg)` }}
          />
        )}
      </div>
    </div>
  );
}
